import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
// Using online image instead of local asset
import about1 from '../assets/images/about1.jpg';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src={about1} alt="Professional photography and clothing" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Why Choose Hemarose Pictures & Badges?</h2>
            <p>Located at Line 3 Ahia Ohuru/New Market, we provide quality pictures, badges, and clothing with excellent customer service and reliable delivery across Nigeria.</p>
            
            <div className="features">
              {[
                { icon: 'fas fa-award', title: 'Quality Products', desc: 'We offer high-quality pictures, badges, and clothing that meet your expectations.' },
                { icon: 'fas fa-clock', title: 'Fast Service', desc: 'Quick and efficient service for all your picture, badge, and clothing needs.' },
                { icon: 'fas fa-shipping-fast', title: 'Nationwide Delivery', desc: 'Reliable waybill services to deliver your orders to different parts of Nigeria.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '3+', label: 'Years Experience' },
              { number: '500+', label: 'Happy Customers' },
              { number: '100%', label: 'Quality Guarantee' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;